let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jrOor")).then(() => parcelRequire('2D4CV'));